export default "__VITE_ASSET__DGgEzQIO__ 600w";